import { databaseRef } from "../Utilities/firebase";
import { store } from "../Store/store";
import orderList from "../Utilities/orderList";
import categorizeList from "../Utilities/categorizeList";

/* ------------- ACTIONS ------------- */
export const ADD_USER = "ADD_USER";
export const REMOVE_USER = "REMOVE_USER";
export const LOAD_USER = "LOAD_USER";
export const UPDATE_SORTED_INVENTORY = "UPDATE_SORTED_INVENTORY";
export const UPDATE_SORTED_TRASH = "UPDATE_SORTED_TRASH";
export const UPDATE_SORTED_SHOPPING = "UPDATE_SORTED_SHOPPING";
export const REMOVE_FIREBASE_LISTENERS = "REMOVE_FIREBASE_LISTENERS";
export const SIGN_OUT = "SIGN_OUT";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SHOW_SELECTED_CATEGORY = "SHOW_SELECTED_CATEGORY";
export const SET_CATEGORY = "SET_CATEGORY";
export const FETCH_INVENTORY = "FETCH_INVENTORY";
export const FETCH_SHOPPING = "FETCH_SHOPPING";
export const FETCH_TRASH = "FETCH_TRASH";
export const UPDATE_ITEM_CATEGORY = "UPDATE_ITEM_CATEGORY";
export const GET_DATA_FOR_STATISTICS = "GET_DATA_FOR_STATISTICS";
export const SAVE_REPORT = "SAVE_REPORT";

/* ------------- ACTION CREATORS ------------- */

export function getDataForStatistics(username) {
  /* USED TO GENERATE STATISTICS REPORTS */
  var firebaseCall = databaseRef.ref("users/" + username);

  return (dispatch) => {
    firebaseCall.once("value", (snapshot) => {
      var userObject = snapshot.val();
      let reports = userObject.reports ? userObject.reports : {};
      let inventory = userObject.inventory ? userObject.inventory : {};
      let trash = userObject.trash ? userObject.trash : {};

      dispatch({
        type: GET_DATA_FOR_STATISTICS,
        payload: {
          reportData: { inventory, trash, reports },
        },
      });
    });
  };
}

export function saveReport(username, type, timeStamp, report) {
  let year = new Date().getUTCFullYear();
  return (dispatch) => {
    databaseRef.ref(`users/"${username}/reports/${year}/${type}`).update({
      [timeStamp]: report,
    });

    dispatch({
      type: SAVE_REPORT,
    });
  };
}

export function addFirebaseListeners(username) {
  var firebaseCall = databaseRef.ref("users/" + username);

  return (dispatch) => {
    dispatch(addInventoryListener(username));
    dispatch(addShoppingListener(username));
    dispatch(addTrashListener(username));

    firebaseCall.once("value", (snapshot) => {
      var userObject = snapshot.val();

      dispatch({
        type: LOAD_USER,
        payload: {
          user: userObject,
          listenerActive: true,
        },
      });
    });
  };
}

export function addInventoryListener(username) {
  var firebaseCall = databaseRef.ref("users/" + username + "/inventory");
  return (dispatch) => {
    firebaseCall.on("value", (snapshot) => {
      let category = store.getState().firebase.category;
      let screen = store.getState().mainScreen.mainScreenMode;
      var inventory = snapshot.val();

      var listOrder = store.getState().firebase.listOrder;
      if (listOrder === undefined) {
        listOrder = "date newest";
      }

      dispatch({
        type: FETCH_INVENTORY,
      });
      if (category !== "all" && screen === "inventory") {
        categorizeList(category, screen);
      } else {
        orderList(inventory, listOrder, "inventory");
      }
    });
  };
}

export function addShoppingListener(username) {
  var firebaseCall = databaseRef.ref("users/" + username + "/shopping");
  return (dispatch) => {
    firebaseCall.on("value", (snapshot) => {
      let category = store.getState().firebase.category;
      let screen = store.getState().mainScreen.mainScreenMode;
      var shopping = snapshot.val();
      var listOrder = store.getState().firebase.listOrder;
      if (listOrder === undefined) {
        listOrder = "date newest";
      }

      dispatch({
        type: FETCH_SHOPPING,
      });
      if (category !== "all" && screen === "shopping") {
        categorizeList(category, screen);
      } else {
        orderList(shopping, listOrder, "shopping");
      }
    });
  };
}

export function addTrashListener(username) {
  var firebaseCall = databaseRef.ref("users/" + username + "/trash");
  return (dispatch) => {
    firebaseCall.on("value", (snapshot) => {
      let category = store.getState().firebase.category;
      let screen = store.getState().mainScreen.mainScreenMode;
      var trash = snapshot.val();

      var listOrder = store.getState().firebase.listOrder;
      if (listOrder === undefined) {
        listOrder = "date newest";
      }

      dispatch({
        type: FETCH_TRASH,
      });
      if (category !== "all" && screen === "trash") {
        categorizeList(category, screen);
      } else {
        orderList(trash, listOrder, "trash");
      }
    });
  };
}

export function removeFirebaseListener(username) {
  var firebaseInvCall = databaseRef.ref("users/" + username + "/inventory");
  var firebaseShopCall = databaseRef.ref("users/" + username + "/shopping");
  var firebaseTrashCall = databaseRef.ref("users/" + username + "/trash");
  firebaseInvCall.off();
  firebaseShopCall.off();
  firebaseTrashCall.off();

  return {
    type: REMOVE_FIREBASE_LISTENERS,
    payload: { listenerActive: false },
  };
}

export function addUser(uid, email, language) {
  return (dispatch) => {
    databaseRef.ref("users/" + uid).set({
      email: email,
      username: uid,
      language: language,
    });

    dispatch({
      type: ADD_USER,
      payload: {
        username: uid,
        language: language,
        email: email,
      },
    });
  };
}

export function setLanguage(uid, language) {
  return (dispatch) => {
    databaseRef.ref("users/" + uid).update({
      language: language,
    });

    dispatch({
      type: SET_LANGUAGE,
      payload: {
        language: language,
      },
    });
  };
}

export const updateSortedTrash = (list, order) => ({
  type: UPDATE_SORTED_TRASH,
  payload: { list: list, order: order },
});

export const updateSortedInventory = (list, order) => ({
  type: UPDATE_SORTED_INVENTORY,
  payload: { list: list, order: order },
});

export const updateSortedShopping = (list, order) => ({
  type: UPDATE_SORTED_SHOPPING,
  payload: { list: list, order: order },
});
export const showSelectedCategory = (list, from, category) => {
  return (dispatch) => {
    let listOrder = store.getState().firebase.listOrder;
    orderList(list, listOrder, from);
    dispatch({
      type: SHOW_SELECTED_CATEGORY,
      payload: {
        category: category,
      },
    });
  };
};

export const setCategory = (category) => ({
  type: SET_CATEGORY,
  payload: { category: category },
});

export const signOut = () => ({
  type: SIGN_OUT,
});

export function updateItemCategory(user, EAN, cat_name) {
  var item = {
    cat_name: cat_name,
  };
  databaseRef
    .ref("users/" + user + "/inventory")
    .child(EAN)
    .update(item);

  return { type: UPDATE_ITEM_CATEGORY };
}
